import { SkeletonProvider } from './SkeletonProvider';
export class SeatGeekProvider extends SkeletonProvider { constructor() { super({ id: 'seatgeek', name: 'SeatGeek', authStrategy: 'api_key', documentationUrl: 'https://platform.seatgeek.com/' }); } }
